'use client';

// Client island: registers web-vitals listeners after hydration.

import { useEffect } from 'react';
import { registerWebVitals } from '@/lib/webVitals';

export default function WebVitals() {
  useEffect(() => {
    registerWebVitals();
  }, []);
  return null;
}
